import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "series-action-choice" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "d-flex align-items-center mb-3" }
const _hoisted_4 = { class: "mb-0 text-muted" }
const _hoisted_5 = { class: "bg-light rounded p-3 mb-4" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = { class: "fw-semibold" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "fw-semibold" }
const _hoisted_11 = { class: "action-options" }
const _hoisted_12 = { class: "row g-3" }
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { class: "form-check" }
const _hoisted_16 = {
  class: "form-check-label w-100",
  for: "action-instance"
}
const _hoisted_17 = { class: "d-flex align-items-center mb-2" }
const _hoisted_18 = { class: "text-muted mb-2" }
const _hoisted_19 = { class: "bg-white border rounded p-2" }
const _hoisted_20 = { class: "fw-semibold" }
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = { class: "form-check" }
const _hoisted_24 = {
  class: "form-check-label w-100",
  for: "action-series"
}
const _hoisted_25 = { class: "d-flex align-items-center mb-2" }
const _hoisted_26 = { class: "text-muted mb-0" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "fas fa-calendar-day me-2"
}
const _hoisted_29 = {
  key: 1,
  class: "fas fa-calendar-alt me-2"
}

import { ref, computed, watch } from "vue";
import BaseModal from "./BaseModal.vue";


export default {
  __name: 'SeriesActionChoiceDialog',
  props: {
  show: { type: Boolean, default: false },
  action: { type: String, required: true }, // 'edit' or 'delete'
  booking: { type: Object, required: true },
},
  emits: ['close', 'confirm'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Local state
const selectedAction = ref('instance'); // Default to instance action

// Computed properties
const modalTitle = computed(() => {
  return props.action === 'edit' 
    ? 'Buchung bearbeiten' 
    : 'Buchung löschen';
});

const actionText = computed(() => {
  return props.action === 'edit' ? 'bearbeiten' : 'löschen';
});

// Format the recurrence pattern for display
function formatPattern(pattern) {
  if (!pattern) return 'Unbekannt';
  
  // Simple pattern parsing - could be enhanced
  if (pattern.includes('FREQ=DAILY')) {
    const countMatch = pattern.match(/COUNT=(\d+)/);
    return countMatch ? `Täglich (${countMatch[1]} Termine)` : 'Täglich';
  }
  if (pattern.includes('FREQ=WEEKLY')) {
    const countMatch = pattern.match(/COUNT=(\d+)/);
    return countMatch ? `Wöchentlich (${countMatch[1]} Termine)` : 'Wöchentlich';
  }
  if (pattern.includes('FREQ=MONTHLY')) {
    const countMatch = pattern.match(/COUNT=(\d+)/);
    return countMatch ? `Monatlich (${countMatch[1]} Termine)` : 'Monatlich';
  }
  return pattern;
}

// Format booking date for display
function formatBookingDate(booking) {
  if (!booking?.startTime) return '';
  
  try {
    const start = new Date(booking.startTime);
    const end = new Date(booking.endTime);
    
    return `${start.toLocaleDateString('de-DE', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })} ${start.toLocaleTimeString('de-DE', {
      hour: '2-digit',
      minute: '2-digit',
    })} - ${end.toLocaleTimeString('de-DE', {
      hour: '2-digit',
      minute: '2-digit',
    })}`;
  } catch (error) {
    console.warn('Failed to format booking date:', error);
    return booking.startTime;
  }
}

// Get description for instance action
function getInstanceActionDescription() {
  if (props.action === 'edit') {
    return 'Nur dieser eine Termin wird geändert und von der Serie getrennt. ' +
           'Die anderen Termine der Serie bleiben unverändert.';
  } else {
    return 'Nur dieser eine Termin wird abgesagt. Die anderen Termine der Serie bleiben bestehen.';
  }
}

// Get description for series action
function getSeriesActionDescription() {
  if (props.action === 'edit') {
    return 'Alle zukünftigen Termine der Serie werden entsprechend angepasst. ' +
           'Bereits vergangene Termine bleiben unverändert.';
  } else {
    return 'Die gesamte Serie wird abgesagt. Alle Termine (auch zukünftige) werden gelöscht.';
  }
}

// Get confirm button text
function getConfirmButtonText() {
  if (!selectedAction.value) return 'Auswählen';
  
  if (selectedAction.value === 'instance') {
    return props.action === 'edit' ? 'Termin bearbeiten' : 'Termin löschen';
  } else {
    return props.action === 'edit' ? 'Serie bearbeiten' : 'Serie löschen';
  }
}

// Handle confirm action
function handleConfirm() {
  if (!selectedAction.value) return;
  
  emit('confirm', {
    action: props.action,
    scope: selectedAction.value, // 'instance' or 'series'
    booking: props.booking,
  });
}

// Reset selection when modal opens
watch(() => props.show, (show) => {
  if (show) {
    selectedAction.value = 'instance'; // Default to instance
  }
});

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(BaseModal, {
    show: __props.show,
    title: modalTitle.value,
    size: "lg",
    "modal-id": "seriesActionChoiceModal",
    onClose: _cache[3] || (_cache[3] = $event => (_ctx.$emit('close')))
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-info me-2" }, [
              _createElementVNode("i", { class: "fas fa-info-circle fa-lg" })
            ], -1 /* CACHED */)),
            _createElementVNode("div", null, [
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mb-1 fw-bold" }, " Diese Buchung ist Teil einer Serie. ", -1 /* CACHED */)),
              _createElementVNode("p", _hoisted_4, " Möchten Sie nur diesen einzelnen Termin oder die gesamte Serie " + _toDisplayString(actionText.value) + "? ", 1 /* TEXT */)
            ])
          ]),
          _createCommentVNode(" Series Information "),
          _createElementVNode("div", _hoisted_5, [
            _cache[8] || (_cache[8] = _createElementVNode("h6", { class: "mb-2" }, [
              _createElementVNode("i", { class: "fas fa-repeat me-2" }),
              _createTextVNode(" Serien-Information ")
            ], -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[6] || (_cache[6] = _createElementVNode("small", { class: "text-muted" }, "Titel:", -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_8, _toDisplayString(__props.booking?.title), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[7] || (_cache[7] = _createElementVNode("small", { class: "text-muted" }, "Muster:", -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_10, _toDisplayString(formatPattern(__props.booking?.series?.pattern)), 1 /* TEXT */)
              ])
            ])
          ]),
          _createCommentVNode(" Action Options "),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createCommentVNode(" Option 1: Single Instance "),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", {
                  class: _normalizeClass(["card border-primary", {
                    'bg-light': selectedAction.value === 'instance',
                  }])
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _withDirectives(_createElementVNode("input", {
                        id: "action-instance",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((selectedAction).value = $event)),
                        class: "form-check-input",
                        type: "radio",
                        value: "instance"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelRadio, selectedAction.value]
                      ]),
                      _createElementVNode("label", _hoisted_16, [
                        _createElementVNode("h6", _hoisted_17, [
                          _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-calendar-day text-primary me-2" }, null, -1 /* CACHED */)),
                          _createTextVNode(" Nur diesen Termin " + _toDisplayString(actionText.value), 1 /* TEXT */)
                        ]),
                        _createElementVNode("p", _hoisted_18, _toDisplayString(getInstanceActionDescription()), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_19, [
                          _cache[10] || (_cache[10] = _createElementVNode("small", { class: "text-muted" }, "Betrifft:", -1 /* CACHED */)),
                          _createElementVNode("div", _hoisted_20, _toDisplayString(formatBookingDate(__props.booking)), 1 /* TEXT */)
                        ])
                      ])
                    ])
                  ])
                ], 2 /* CLASS */)
              ]),
              _createCommentVNode(" Option 2: Entire Series "),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", {
                  class: _normalizeClass(["card border-success", {
                    'bg-light': selectedAction.value === 'series',
                  }])
                }, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _withDirectives(_createElementVNode("input", {
                        id: "action-series",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((selectedAction).value = $event)),
                        class: "form-check-input",
                        type: "radio",
                        value: "series"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelRadio, selectedAction.value]
                      ]),
                      _createElementVNode("label", _hoisted_24, [
                        _createElementVNode("h6", _hoisted_25, [
                          _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fas fa-calendar-alt text-success me-2" }, null, -1 /* CACHED */)),
                          _createTextVNode(" Gesamte Serie " + _toDisplayString(actionText.value), 1 /* TEXT */)
                        ]),
                        _createElementVNode("p", _hoisted_26, _toDisplayString(getSeriesActionDescription()), 1 /* TEXT */)
                      ])
                    ])
                  ])
                ], 2 /* CLASS */)
              ])
            ])
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit('close')))
      }, " Abbrechen "),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn", selectedAction.value === 'instance' ? 'btn-primary' : 'btn-success']),
        disabled: !selectedAction.value,
        onClick: handleConfirm
      }, [
        (selectedAction.value === 'instance')
          ? (_openBlock(), _createElementBlock("i", _hoisted_28))
          : (selectedAction.value === 'series')
            ? (_openBlock(), _createElementBlock("i", _hoisted_29))
            : _createCommentVNode("v-if", true),
        _createTextVNode(" " + _toDisplayString(getConfirmButtonText()), 1 /* TEXT */)
      ], 10 /* CLASS, PROPS */, _hoisted_27)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show", "title"]))
}
}

}